export default __webpack_public_path__ + "static/5-d9f83d3b5d5bbe3d17c7f6dbf657ec8f.png";